export default "__VITE_ASSET__lv4fK7Os__"